import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Footer.css';

function Footer() {

  return (
    <>
    <footer>

  

    {/* line */}
    

    <div className='down_footer'>
      <h4>Devpuri mana Road Raipur Chhattisgarh, India. Call:  <h5><a href='tel:7714050996' style={{textDecoration:"none", color:'#FFFF'}}><FontAwesomeIcon  icon={faPhone} />CALL: 07714050996</a></h5>   <h5><a href='mailto:pooja@godriwala.com' style={{textDecoration:"none", color:'#FFFF'}}><FontAwesomeIcon icon={faEnvelope}  />Email:pooja@godriwala.com</a></h5></h4>
      
      <h4 >© 2024 Pooja Plastics. All rights reserved. </h4>
    </div>
    </footer>
    </>
  )
}

export default Footer
